import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { transformKeysToCamelCase } from '../../utils/caseTransformers';
import { GetBillingQuotaBalanceResponse } from '../httpClients/BillingClient/api.schema';
import { BillingClient } from '../httpClients/BillingClient/BillingClient';
import { QUERY_KEYS } from './consts';

type OmittedQueryOptions = Omit<
  UseQueryOptions<GetBillingQuotaBalanceResponse>,
  'queryKey' | 'queryFn' | 'select'
>;

export const useBillingQuotaBalanceQuery = (
  queryOptions: OmittedQueryOptions = {},
) =>
  useQuery({
    queryKey: [QUERY_KEYS.BILLING_QUOTA_BALANCE],
    queryFn: () => BillingClient.getBillingQuotaBalance(),
    select: (data): GetBillingQuotaBalanceResponse =>
      transformKeysToCamelCase(data),
    ...queryOptions,
  });
